import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sections" }
const _hoisted_2 = { class: "sections-content" }
const _hoisted_3 = {
  key: 0,
  class: "md-block"
}
const _hoisted_4 = { ref: "scroll_bottom" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SectionTitle = _resolveComponent("SectionTitle")
  const _component_MdContent = _resolveComponent("MdContent")
  const _component_PulseActions = _resolveComponent("PulseActions")
  const _component_SignalActivity = _resolveComponent("SignalActivity")
  const _component_SignalSources = _resolveComponent("SignalSources")
  const _component_SignalAbout = _resolveComponent("SignalAbout")
  const _component_Chart = _resolveComponent("Chart")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Divider = _resolveComponent("Divider")
  const _component_SignalBottom = _resolveComponent("SignalBottom")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ScrollBar, {
      ref: "scrollbar",
      class: "scrollbar",
      onWheel: _cache[0] || (_cache[0] = $event => ($options.observeAnchors())),
      onTouchstart: _cache[1] || (_cache[1] = $event => ($options.observeAnchors()))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sections, (section, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: _normalizeClass(["segment", {[section.type]: true}])
            }, [
              _createVNode(_component_SectionTitle, {
                ref_for: true,
                ref: section.anchor,
                "data-anchor": section.anchor,
                title: section.title,
                line: ['about', 'sources'].includes(section.type)
              }, null, 8 /* PROPS */, ["data-anchor", "title", "line"]),
              (section.type === 'markdown')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_MdContent, {
                      class: "md",
                      markdown: section.data
                    }, null, 8 /* PROPS */, ["markdown"]),
                    ($options.sections[idx + 1]?.type === 'sources')
                      ? (_openBlock(), _createBlock(_component_PulseActions, {
                          key: 0,
                          class: "actions",
                          teleported: "",
                          "pulse-item": $props.item,
                          show: "",
                          size: "1.6rem"
                        }, null, 8 /* PROPS */, ["pulse-item"]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              (section.type === 'recent_activity')
                ? (_openBlock(), _createBlock(_component_SignalActivity, {
                    key: 1,
                    steps: section.data,
                    total: $props.item.feed_count,
                    name: $props.item.entity_name,
                    "entity-id": $props.item.entity_id
                  }, null, 8 /* PROPS */, ["steps", "total", "name", "entity-id"]))
                : _createCommentVNode("v-if", true),
              (section.type === 'sources')
                ? (_openBlock(), _createBlock(_component_SignalSources, {
                    key: 2,
                    data: section.data
                  }, null, 8 /* PROPS */, ["data"]))
                : _createCommentVNode("v-if", true),
              (section.type === 'about')
                ? (_openBlock(), _createBlock(_component_SignalAbout, {
                    key: 3,
                    data: section.data
                  }, null, 8 /* PROPS */, ["data"]))
                : _createCommentVNode("v-if", true),
              (section.type === 'stock')
                ? (_openBlock(), _createBlock(_component_Chart, {
                    key: 4,
                    data: section.data
                  }, null, 8 /* PROPS */, ["data"]))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */)),
          _createCommentVNode(" scroll-bottom node is our indication anchor of bottom reachment "),
          _createElementVNode("div", _hoisted_4, null, 512 /* NEED_PATCH */)
        ])
      ]),
      _: 1 /* STABLE */
    }, 512 /* NEED_PATCH */),
    _createVNode(_component_Divider, { m: "0 -2.4rem 1.6rem" }),
    _createVNode(_component_SignalBottom, {
      class: "bottom",
      item: $props.item,
      mode: $props.tab
    }, null, 8 /* PROPS */, ["item", "mode"])
  ]))
}